import { dividerStyles } from 'styles/theme';
import styled from '@emotion/styled';

type Props = {
  type?: 'horizontal' | 'vertical';
};

export default styled.div<Props>((props) => ({
  backgroundColor: dividerStyles.colors.primary,
  width: props.type === 'vertical' ? 1 : undefined,
  height: props.type === 'vertical' ? undefined : 1,
}));
